import type { App } from 'vue'
import { useTitle } from '@vueuse/core'
import { createRouter, createWebHashHistory, createWebHistory } from 'vue-router'
import { transformAuthRoutesToVueRoutes, createPermissionGuard } from '@/utils'
import { useAppStore, useRouteStore } from '@/store'
import Routes from './routes'

export const router = createRouter({
    history: createWebHashHistory(),
    routes: transformAuthRoutesToVueRoutes(Routes),
})

router.beforeEach(async (to, from, next) => {
    const appStore = useAppStore()
    const routeStore = useRouteStore()
    appStore.setRouterLoading(true)

    // 如果正在初始化路由，等待一下确保完成
    if (routeStore.isAddingRoute) {
        await new Promise(resolve => setTimeout(resolve, 100))
    }

    try {
        // 页面跳转权限处理
        await createPermissionGuard(to, from, next, router)
    } catch (error) {
        console.error('路由跳转错误:', error)
        // 确保next被调用
        next({ path: to.fullPath, replace: true, query: to.query })
    }
})

// 添加路由错误处理
router.onError((error) => {
    console.error('路由错误:', error)
    // 刷新页面
    window.location.reload()
})

router.afterEach((to) => {
    const appStore = useAppStore()
    appStore.setRouterLoading(false)
    // 设置document title
    useTitle(to.meta.title)
})

export async function setupRouter(app: App) {
    app.use(router)
    await router.isReady()
}

